import { render, staticRenderFns } from "./mallGoodsSkuLog.vue?vue&type=template&id=05ba34a2&"
import script from "./mallGoodsSkuLog.vue?vue&type=script&lang=js&"
export * from "./mallGoodsSkuLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports